import { LOGO } from "@/lib/site";

export const Header = () => (
  <>
    {/* Top Contact Header */}
    <header className="bg-graphite text-slate-300 border-b border-slate-800" data-testid="top-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex flex-wrap items-center justify-between text-xs">
        <div className="flex items-center gap-6">
          <span className="font-bold text-white tracking-wide" data-testid="firm-title">DIAMOND V, LLC · OHIO GEOMATICS</span>
          <span className="hidden sm:inline text-slate-400">Dublin &amp; Central Ohio Professional Practice</span>
        </div>
        <div className="flex items-center gap-6">
          <a href="mailto:steve.l@ohiogeomatics.com" className="text-slate-300 font-semibold hover:text-white transition-colors" data-testid="header-email">steve.l@ohiogeomatics.com</a>
          <a href="#contact" data-testid="header-enquiry-link" className="text-amber-400 hover:text-amber-300 font-bold underline transition-colors">Direct Enquiry</a>
        </div>
      </div>
    </header>

    {/* Sticky Main Nav */}
    <nav className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-stone-200" data-testid="main-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <img src={LOGO} alt="Ohio Geomatics, Ltd. — Surveying, GIS/GPS, Remote Sensing" className="h-12 w-auto" data-testid="nav-logo" />
          <div>
            <span className="block text-lg font-extrabold text-stone-900 leading-none">Steve Lamphear</span>
            <span className="block text-xs font-semibold text-amber-800 uppercase tracking-widest mt-1">PE · PS · RLS Principal</span>
          </div>
        </div>
        <div className="hidden lg:flex items-center gap-8 text-sm font-semibold text-stone-700">
          <a href="#practice" data-testid="nav-practice" className="hover:text-amber-800 transition-colors">Practice</a>
          <a href="#field-gallery" data-testid="nav-field-gallery" className="hover:text-amber-800 transition-colors">Field Gallery</a>
          <a href="#capabilities" data-testid="nav-capabilities" className="hover:text-amber-800 transition-colors">Capabilities</a>
          <a href="#service-radius" data-testid="nav-service-radius" className="hover:text-amber-800 transition-colors">Central Ohio</a>
          <a href="#background" data-testid="nav-background" className="hover:text-amber-800 transition-colors">35-Year Record</a>
          <a href="#contact" data-testid="nav-contact" className="hover:text-amber-800 transition-colors">Contact</a>
        </div>
        <a href="#contact" data-testid="nav-intake-btn" className="inline-flex items-center justify-center px-5 py-2.5 rounded bg-graphite hover:bg-amber-800 text-white text-sm font-semibold transition-colors">
          Direct Project Intake
        </a>
      </div>
    </nav>
  </>
);
